/** Logs only in development — keeps production consoles clean. */
export function devLog(...args) {
  if (process.env.NODE_ENV === "development") {
    console.log(...args);
  }
}
